import { AGENT_ROUTE_NAMES } from '@/agent/types/router'
import { type RouteRecordRaw } from 'vue-router'
import ctiRoutes from '@/cti/routes'
import { agentBeforeEnter, contextualSearchBeforeEnter, caseBeforeEnter, caseWorklogGuard, customerCtiQueryBeforeEnter } from '@/router/guards'

const AgentView = () => import('@/agent/views/AgentView.vue')
const LegacyView = () => import('@/common/views/LegacyView.vue')
const CaseListView = () => import('@/agent/views/CaseListView.vue')
const CaseView = () => import('@/agent/views/CaseView.vue')
const CaseAccessDeniedView = () => import('@/agent/views/CaseAccessDeniedView.vue')
const BaseHeader = () => import('@/agent/components/headers/BaseHeader.vue')
const CustomerView = () => import('@/agent/views/CustomerView.vue')
const NewCustomerView = () => import('@/agent/views/NewCustomerView.vue')
const CaseConverterView = () => import('@/agent/views/CaseConverterView.vue')
const BreaksView = () => import('@/agent/views/BreaksView.vue')
const SupervisionUsersView = () => import('@/agent/views/SupervisionUsersView.vue')
const BaseLegacyView = () => import('@/agent/views/BaseLegacyView.vue')

export default [
  {
    path: '/assist',
    component: AgentView,
    beforeEnter: agentBeforeEnter,
    meta: {
      agent: true,
      legacy: true,
    },
    children: [
      ...ctiRoutes,
      {
        path: 'ticket/show/:caseId',
        component: CaseView,
        name: AGENT_ROUTE_NAMES.CASE_PROCESSING,
        beforeEnter: [caseBeforeEnter, caseWorklogGuard],
        meta: {
          allowBackNavigation: true,
        },
      },
      {
        path: 'ticket/denied/:caseId',
        component: CaseAccessDeniedView,
        name: AGENT_ROUTE_NAMES.CASE_ACCESS_DENIED,
        meta: {
          allowBackNavigation: true,
        },
        props: true,
      },
      {
        path: 'tickets/list',
        component: CaseListView,
        name: AGENT_ROUTE_NAMES.TICKET_LIST,
        beforeEnter: [contextualSearchBeforeEnter],
        meta: {
          exclude: ['/assist/tickets/bulk/bulkSave'],
        },
      },
      {
        path: 'customer/new',
        name: AGENT_ROUTE_NAMES.CUSTOMER_NEW,
        component: NewCustomerView,
        beforeEnter: customerCtiQueryBeforeEnter,
        meta: {
          exclude: ['/assist/customer/save'],
          allowBackNavigation: true,
        },
      },
      {
        path: 'customer/edit/:customerId',
        name: AGENT_ROUTE_NAMES.CUSTOMER_EDIT,
        component: CustomerView,
        beforeEnter: customerCtiQueryBeforeEnter,
        props: (route) => ({
          customerId: route.params.customerId,
        }),
        meta: {
          exclude: ['/assist/customer/delete', '/assist/customer/save'],
          allowBackNavigation: true,
        },
      },
      {
        path: 'entities/:id',
        name: AGENT_ROUTE_NAMES.COMPANY_VIEW,
        component: () => import('@/agent/components/company/CompanyView.vue'),
        props: true,
        meta: {
          legacy: false,
          allowBackNavigation: true,
        },
      },
      {
        path: ':channel/create/:id',
        component: CaseConverterView,
        meta: {
          exclude: ['/assist/sms/save', '/assist/whatsapp/save'],
          allowBackNavigation: true,
          skipHistory: true,
        },
      },
      {
        path: 'pause/start/:id',
        component: BreaksView,
      },
      {
        path: 'stats/:url+',
        component: BaseLegacyView,
        props: {
          menu: true,
        },
      },
      {
        path: 'stats/supervision/users',
        component: SupervisionUsersView,
        props: {
          menu: true,
        },
      },
      {
        path: 'stats/supervision/connections',
        component: SupervisionUsersView,
        props: {
          menu: true,
        },
      },
      {
        path: 'imports/init',
        component: BaseLegacyView,
        props: {
          menu: true,
        },
      },
      {
        path: 'exclusions/init',
        component: BaseLegacyView,
        props: {
          menu: true,
        },
      },
    ],
  },
  {
    path: '/assist',
    component: LegacyView,
    beforeEnter: agentBeforeEnter,
    meta: {
      legacy: true,
      agent: true,
    },
    children: [
      {
        path: 'ticket/create/oneclick/:skillGroupId',
        component: BaseHeader,
        meta: {
          allowBackNavigation: true,
          skipHistory: true,
        },
      },
      {
        path: 'user/myprofile',
        component: BaseHeader,
        props: {
          menu: true,
        },
      },
    ],
  },
] as Array<RouteRecordRaw>
